import React from 'react'
import './Machine.css';
import upGreen from './media/upgreen_transparent.png';
import downRed from './media/downred_transparent.png';
import Linkify from 'react-linkify';
import Timestamp from './Timestamp';
import Collapsible from 'react-collapsible';
import ReactDOM from 'react-dom';

function httpPostReboot(theUrl: string, machineIp: string)  {

    let secretKey = prompt("Please enter key:");

    // confirmation window to confirm that user wants to reboot 3dApp
    if (window.confirm("You are rebooting 3DApp on machine " + theUrl + " please confirm")) {

        // add endpoint to hostname
        theUrl += "/reboot";
        
        // calculate POST body and setup
        var jsonBody: any = {};
        jsonBody.ipForMachine = machineIp;
        jsonBody.secretKey = secretKey;

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify(jsonBody);
    
        var requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
        };

        // fetch call that sends post request
        fetch(theUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(result);
            console.log(result);
        })
        .catch(error => {
            alert(error)
            console.log('error ', error)
        });
    } else {

    }
}

function httpPostRestartMachine(theUrl: string, machineIp: string)  {

    let secretKey = prompt("Please enter key:");

    // confirmation window to confirm that user wants to reboot 3dApp
    if (window.confirm("You are rebooting machine " + theUrl + " please confirm")) {

        // add endpoint yo hostname
        theUrl += "/restartMachine";
        
        // calculate POST body and setup
        var jsonBody: any = {};
        jsonBody.ipForMachine = machineIp;
        jsonBody.secretKey = secretKey;

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify(jsonBody);
    
        var requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
        };

        // fetch call that sends post request
        fetch(theUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(result);
            console.log(result);
        })
        .catch(error => {
            alert(error)
            console.log('error ', error)
        });
    } else {

    }
}

const UpStatus = () => (
    <>
        <div className="statusUp">
            <img src={upGreen} alt="status is up" className="upGreen" />
        </div>
        <div className="sessionUp">Session Up</div>
    </>
)

const DownStatus = ()=> (
    <>
        <div className="statusDown">
            <img src={downRed} alt="status is down" className="downRed"/>
        </div>
        <div className="sessionDown">Session Down</div>
    </>
)

export interface iMachineProps {
    healthy: boolean;
    hostName: string;
    sessionIP: string;
    sessionUrl: string;
    agentIP: string;
    vmAgentVersion: string;
    threeDAppVersion: string;
    lastUpdated: string;
    status: string;
    modelyear: string;
    country: string;
    currentCarline: string;
    appId: string;
    healthCheckRetryCount: number;
    machineIsAvailable: boolean;
    datacenter: string;

}

interface logState {
    logs: String
}

class Machine extends React.Component<iMachineProps, logState> {

    constructor(props: any) {
        super(props)

        this.state = {
            logs: ""
        }
    }

    UpdatePathValidator(path:string) {

        // takes filename from path
        let fullFileName = path.split("/").pop();
        let fileNameStart = fullFileName?.split("-").shift();

        // filename does not start with InvictusVehicleConfigurator return false
        return fileNameStart != "InvictusVehicleConfigurator" ? false : true;
    }

    PreInstallPathValidator(path:string) {

        // takes filename from path
        let fullFileName = path.split("/").pop();
        let fileNameStart = fullFileName?.split("-").shift();

        // filename does not start with InvictusVehicleConfigurator return false
        if (fileNameStart != "InvictusVehicleConfigurator"){
            return false;
          }
  
          // path same for prod, dev, qa and test
          return path.includes("3dAppBuilds/") && path.endsWith(".zip") ? true : false;
    }

    CallEndpoint(theUrl: string, machineId: string){

        var endpoint = document.querySelector('input[name="endpoint"]:checked') as HTMLInputElement;
        var path = document.getElementById(`${machineId}/callEndpoint`)! as HTMLInputElement;

        // if (updatePathValidator || preinstallPathValidator) {}

        if (endpoint.value === "update3DApp") {

            if (!this.UpdatePathValidator(path.value)) {
                alert('Invalid path')
                return;
            }

        } else if (endpoint.value === "preInstallBuild") {

            if (!this.PreInstallPathValidator(path.value)) {
                alert('Invalid path')
                return;
            }
        }

        let secretKey = prompt("Please enter key:");

        this.setState({
            logs: 'Calling endpoint...'
        })

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        let jsonBody: any = {};
        let raw: string;

        if (endpoint.value === "update3DApp") {

            theUrl += "/update3DApp";
            jsonBody.new3DAppName = path.value;
            jsonBody.secretKey = secretKey;
            
        } else if (endpoint.value === "preInstallBuild") {

            theUrl += "/preInstallBuild";
            jsonBody.fileName = path.value;

        } else if (endpoint.value === "validate3dAppInstalled") {

            theUrl += "/validate3dAppInstalled";
            jsonBody.fileName = path.value;

        } else {
            alert("Please select enpoint");
            return;
        }

        raw = JSON.stringify(jsonBody);

        var requestOptions: RequestInit = {
            method: 'POST',
            headers: myHeaders,
            body: raw 
        };

        fetch(theUrl, requestOptions)
            .then(response => response.text())
            .then(result => {
                this.setState({
                    logs: result
                })
            })
            .catch(error => {
                this.setState({
                    logs: String(error)
                })
            });
    }

    UpdateApplication(theUrl: string, machineId: string){

        let secretKey = prompt("Please enter key:");

        this.setState({
            logs: "Calling update..."
        })

        var application = document.querySelector('input[name="application"]:checked') as HTMLInputElement;
        var path = document.getElementById(`${machineId}`)! as HTMLInputElement;
        theUrl += "/updateApplication";

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        let jsonBody: any = {};
        let raw: string;

        if (application.value === "vmagent") {
            jsonBody.applicationToUpdate = "vmagent";
            jsonBody.filenameInS3 = path.value;
            jsonBody.secretKey = secretKey;
            raw = JSON.stringify(jsonBody);
        } else if (application.value === "3dapp") {
            jsonBody.applicationToUpdate = "3dapp";
            jsonBody.filenameInS3 = path.value;
            jsonBody.secretKey = secretKey;
            raw = JSON.stringify(jsonBody);
        } else {
            alert("Please select either vmagent or 3dapp");
            return;
        }

        var requestOptions: RequestInit = {
            method: 'POST',
            headers: myHeaders,
            body: raw 
        };

        fetch(theUrl, requestOptions)
            .then(response => response.text())
            .then(result => {
                this.setState({
                    logs: result
                })
            })
            .catch(error => {
                this.setState({
                    logs: String(error)
                })
            });
    }

    render() {
        // checking state of health for status image
            return <div className={this.props.healthy ? 'individualMachineUp':'individualMachineDown'}>
                    <div className="box1">
                        {/* <button type="submit" onClick={() => httpPostReboot(this.props.hostName, this.props.sessionIP)} id="btn "className="restart">Reboot</button> */}
                        { this.props.healthy ? <UpStatus /> : <DownStatus /> }
                        <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (<a target="_blank" href={this.props.sessionUrl} key={key} rel="noopener noreferrer">{decoratedText} </a>)}>
                            <div>Session URL: </div>
                            <div>{this.props.sessionUrl}</div></Linkify>
                        <div>Session IP: {this.props.sessionIP}</div>
                        <a href={`${this.props.hostName}/vmAgentInfo`} target="_blank" rel="noopener noreferrer">Host Name: {this.props.hostName}</a>
                        <div>Host IP: {this.props.agentIP}</div>
                        <div>VMAgent Version: {this.props.vmAgentVersion}</div>
                        <div>Unreal application Version: {this.props.threeDAppVersion}</div>
                        <div>Last Updated: <Timestamp timestring={this.props.lastUpdated}/></div>
                    </div>

                    <div className="box2">

                        <div>Status: {this.props.status}</div>
                        <div>Country: {this.props.country}</div>
                        <div>Current Vehicle: {this.props.currentCarline}</div>
                        <div>Model Year: {this.props.modelyear}</div>
                        <div>App ID: {this.props.appId}</div>
                        <div>Healthy: {this.props.healthy ? 'True' : 'False'}</div>
                        <div>Health Check Retry Count: {this.props.healthCheckRetryCount}</div>
                        <div>Machine Available: {this.props.machineIsAvailable ? 'True' : 'False'}</div>

                    </div>

                    <div className="box3">
                        <Collapsible trigger="More Options">
                            <ul id="postData-machine">

                                <div className="restartScripts">
                                    <h4>Restart Scripts</h4>
                                    <button type="submit" onClick={() => httpPostReboot(this.props.hostName, this.props.sessionIP)} id="btn "className="">Reboot 3dApp</button>
                                    <button type="submit" onClick={() => httpPostRestartMachine(this.props.hostName, this.props.sessionIP)} id="btn "className="">Restart Machine</button>
                                </div>

                                <div className="selectApplication">
                                    <h4>Update VmAgent</h4>
                                    <input type="radio" name="application" value="vmagent"/> vmagent 
                                    <input type="radio" name="application" value="3dapp"/> 3dapp
                                </div>

                                <div className="updatePath">
                                    <h4>Enter filepath</h4>
                                    <input type="text" id={`${this.props.sessionIP}`} name="path"/>

                                    <button onClick={() => this.UpdateApplication(this.props.hostName, this.props.sessionIP)}>Submit</button>
                                </div>

                                <div>
                                    <div className="selectEndpoint">
                                        <h4>Deployment Manager Endpoints</h4> 
                                        <input type="radio" name="endpoint" value="preInstallBuild"/> preInstallBuild
                                        <input type="radio" name="endpoint" value="validate3dAppInstalled"/> validate3dAppInstalled
                                        <input type="radio" name="endpoint" value="update3DApp"/> update3DApp
                                    </div>

                                    <div className="endpointPath">
                                        <h4>Enter filepath</h4>
                                        <input type="text" id={`${this.props.sessionIP}/callEndpoint`} name="path"/>

                                        <button onClick={() => this.CallEndpoint(this.props.hostName, this.props.sessionIP)}>Submit</button>
                                    </div>
                                </div>

                                <div className="logs" id={`${this.props.sessionIP}` + `logs`}>
                                    <h4>Logs</h4>
                                    <p>{this.state.logs}</p>
                                </div>
                            </ul>
                        </Collapsible>
                        
                    </div>
            </div>
    }
}
export default Machine;
